import React, {memo, useCallback, useEffect, useMemo} from 'react';
import {Container} from '../../components/Container';
import {Row} from '../../components/Row';
import {useDispatch, useSelector} from 'react-redux';
import {Control} from '../../components/ItemList/control';
import {useSetSelector} from '../../hooks/set-selector';
import {Scenario} from '../../components/ItemList/scenario';
import {Sensor} from '../../components/ItemList/sensor';
import {InputModel} from '../../types/control';
import {Media} from '../../components/Controls/AirConditionerControl';
import {useCurrentGateway} from '../../hooks/current-gateway';
import './index.scss';
import {onClickHandler} from '../../utils/onclick';
import {useRPC} from '../../hooks/rpc';
import {useMessage} from '../../hooks/message';
import { useLocalization } from "../../hooks/localization";
import { useHistory } from 'react-router-dom';

import {backButtonToggle, groupSettingAction, scenarioSettingAction} from "../../store/ui/actions";

export const MainScreen = memo(function MainScreen() {
    const {t} = useLocalization();
    const dispatch = useDispatch();
    const gateway = useCurrentGateway();
    const setupMode = useMemo(() => gateway?.settings?.setup_mode || false, [gateway?.settings?.setup_mode]);
    const homePageItemList = useSelector(state => state.control.homepageItemList);
    const controlSet = useSetSelector(state => state.control.controlList);
    const scenarioSet = useSetSelector(state => state.control.scenarioList);
    const inputSet = useSetSelector(state => state.control.inputList);
    const mediaSet = useSetSelector(state => state.control.mediaList);

    const [rpc] = useRPC();
    const {failure} = useMessage();

    const homePageSortedList = useMemo(
        () => homePageItemList.sort((a, b) => a.order - b.order),
        [homePageItemList],
    );

    dispatch(backButtonToggle({is_open: false, to: '/'}));
    dispatch(groupSettingAction({visible: false}));
    dispatch(scenarioSettingAction({visible: true}));

    const switchToHomeMode = useCallback(() => {
        rpc.updateGateway({
            ...gateway,
            settings: {
                ...gateway?.settings,
                setup_mode: false,
            },
        }).catch(failure);
    }, [failure, gateway, rpc]);
    return (
        <Container>
            <div className="page-wrapper" >
                {
                    renderIf(setupMode)(() =>
                        <div className='setup-mode'>
                            <span>{t('SWITCH_TO_HOME_MODE_TO_MANAGE_CONTROLS')}</span>
                            <div className='setup-mode-close' {...onClickHandler(switchToHomeMode)}>
                                <span>{t('SWITCH_TO_HOME_MODE')}</span>
                            </div>
                        </div>, () =>
                        <Row>
                            {
                                homePageSortedList.map(item => {
                                    if (item.type === 'control') {
                                        return <Control key={`control_${item.id}`}
                                                        control={controlSet[item.relational_id]}/>;
                                    }

                                    if (item.type === 'scenario') {
                                        return <Scenario key={`scenario_${item.id}`}
                                                         scenario={scenarioSet[item.relational_id]}/>;
                                    }

                                    if (item.type === 'sensor') {
                                        return <Sensor key={`sensor_${item.id}`}
                                                       sensor={inputSet[item.relational_id] as InputModel}/>;
                                    }

                                    if (item.type === 'media') {
                                        return <Media key={`media_${item.id}`}
                                                      media={mediaSet[item.relational_id]}/>;
                                    }

                                    return null;
                                })
                            }
                        </Row>,
                    )
                }
            </div>
        </Container>
    );
});
